import * as core from '../../../../../../../core'
import * as changeImpactType from '../change-impact-type'

export const RESOURCE = {
  payload: {
    description: 'Terminology',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactType.RESOURCE.payload.partialId,
    }),
    id: 'Terminology',
    name: 'Terminology',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
